import type { FaireProductEntity } from "../../entity_types/product";

export const p_122ivjfkd4: FaireProductEntity = {
  token: "p_122ivjfkd4",
  type: "product",
  name: "Kids Relief Plug-in Waterless Vaporizer + 5 Refill Pads",
  brandToken: "b_7btl61xote",
  brandName: "homeolab International Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/ff9ae28bc2f63c0a2dfce394802a3b0e1edd0a72865a0eeea30780c961164c83.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/87eb09c1e1f2f1b09ef4e9d9d88af4e7ec6c25ef598b78772af0ff2be6984389.png",
    "https://cdn.faire.com/fastly/1554db59ad05154685e952d3d6df5d056b569f41376ed1619a30093180eb49c5.jpeg",
    "https://cdn.faire.com/fastly/6f16ff78bd51d08f75efac7927889f7d83e96ebcca567b08a8c9e535ccfdf5d2.png",
    "https://cdn.faire.com/fastly/d5e8e3c51f5846c17d4db340d859d17f78bfcfc88d048efb80a0b65033c47915.jpeg",
    "https://cdn.faire.com/fastly/09284ddb7c81fd67d55bbd02159d38414266108fbb8cb7ef9adbd4a682adbc15.png",
  ],
  priceDollars: 10.79,
  description:
    "Kids Relief Plug-in Waterless Vaporizer with 5 Soothing Non-Medicated Menthol Eucalyptus Lavender Vapor Universal Refill Pads.\n\nThe Vaporizer releases a blend of non-medicated aromatic vapors to soothe you while you rest. The easy to replace refill pads last up to 8 hours. Plugin the vaporizer and enjoy the benefits that come with its quiet operation.\n\nUp to 8 hours of soothing relief. Real Relief Vaporizer uses non-medicated refill pads designed to provide you relief from cold, cough, & flu with soothing menthol Eucalyptus vapors. BPA-free and ecofriendly waterless Vaporizer. Ideal use in multiple rooms and travel-Friendly design.\n\nIncludes 5X soothing non-medicated menthol eucalyptus refill pads & our soft heat vaporizer. Combines an aromatic blend of ingredients including menthol, eucalyptus and Lavender. Allows for maximum flexibility. Offers soothing relief while you rest.\n\nSafe & effective. CSA (USA & Canada) Approved. Manufactured in a CE & GMP Certified Facility in Canada. ",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:54:24.775Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
